import { makeStyles } from "tss-react/mui";

const useInfoButtonStyles = makeStyles()((theme) => ({
  root: {
    color: theme.palette.text.primary,
  },
  text: {
    padding: theme.spacing(2),
  },
}));

export default useInfoButtonStyles;
